import React from 'react';
import { Helmet } from "react-helmet";
import TelemetryLogs from '../../Components/Admin/TelemetryLogs';
import PrimarySearchAppBar from '../../Components/Layout/Header';
import Footer from '../../Components/Home/Footer'

function index() {
  return (
    <React.Fragment>
    <Helmet titleTemplate="PRSS | %s" title="Telemetry Logs" />
<PrimarySearchAppBar/>
    <TelemetryLogs />
    
  </React.Fragment>
  );
}

export default index;
